import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import { HEALTHCARE_COURSES, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListHealthcareCourses from "./List";
import ShowHealthcareCourses from "./Show";
import EditHealthcareCourses from "./Edit";
import CreateHealthcareCourses from "./Create";

export const resources = {
  isMenu: true,
  icon: <LocalHospitalIcon />,
  name: SpecialistServicePath + HEALTHCARE_COURSES,
  title: "Курсове за здравни грижи",
  list: <ListHealthcareCourses />,
  show: <ShowHealthcareCourses />,
  create: <CreateHealthcareCourses />,
  edit: <EditHealthcareCourses />,
  permission: permissions.canPreviewHealthcareCourses,
  showPermission: permissions.canPreviewHealthcareCourses,
  createPermission: permissions.canManageHealthcareCourses,
  editPermission: permissions.canManageHealthcareCourses,
};
